function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.66852 12.3477C6.67068 10.3499 6.21958 8.35211 6.11781 7.55168C6.08937 7.33036 6.16553 7.10841 6.32387 6.95118L7.94062 5.33517C8.17845 5.09749 8.22065 4.72708 8.04239 4.44199L5.46822 0.44491C5.271 0.129231 4.86607 0.0152997 4.53318 0.18183L0.400721 2.12804C0.131525 2.2606 -0.0268129 2.54661 0.00375136 2.84511C0.22028 4.90211 1.11707 9.95873 6.08641 14.9284C11.0557 19.898 16.1117 20.7945 18.1698 21.011C18.4683 21.0415 18.7543 20.8832 18.8869 20.614L20.8331 16.4816C20.999 16.1494 20.8858 15.7456 20.5715 15.548L16.5744 12.9746C16.2894 12.7961 15.919 12.838 15.6812 13.0756L14.0651 14.6924C13.9079 14.8507 13.686 14.9269 13.4646 14.8984C12.6642 14.7967 10.6664 14.3456 8.66852 12.3477Z",
  fill: "white"
});

var SvgPhoneSmallIc = function SvgPhoneSmallIc(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPhoneSmallIc, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/phone_small_ic.d371bc7d.svg";
export { ForwardRef as ReactComponent };